import Reports from "../../components/reports";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {clearActiveReport, getReportPdf, getTableauReport} from "../../actions/reports";
import ShowReport from "../../components/showReport";
import NoReports from "../../components/noReports";
import {checkSchoolReportsCount} from "../../utils/reports";
import fileDownload from "js-file-download";

const ReportTab = (props) => {
  const {
    tabTitle,
    studentReports,
    schoolReports,
    districtOverviewReports,
    additionalReports,
    reportType,
    showSampleReports,
    backToMyReports,
    useSchoolCount,
    schoolStatuses,
    noReportsMessage,
    setShowBatchReport,
    reportsDistrict,
    backToLabel
  } = props;

  const dispatch = useDispatch();
  const activeReport = useSelector((state) => state.reports.activeReport);
  const pdfReport = useSelector((state) => state.reports.pdfReport);

  const [reportInfo, setReportInfo] = useState(null);
  const [downloadPdfFileName, setDownloadPdfFileName] = useState('');

  async function fetchReport(report) {
    if (report.pdfReport) {
      await dispatch(getReportPdf(report.pdfFileName));
    } else {
      await dispatch(getTableauReport(report.reportEndpoint, report.useCurrentDistrict, reportType, reportsDistrict));
    }
  }

  useEffect(() =>  {
      if (pdfReport && downloadPdfFileName) {
        setDownloadPdfFileName('');
        fileDownload(pdfReport, downloadPdfFileName);
      }
    }, [dispatch, pdfReport, downloadPdfFileName]
  );

  const onClickAction = async (report) => {
    if ((report.pdfReport && !report.pdfFileName) || (report.useEmbedFile && !report.embedFile) || (!report.useEmbedFile && !report.pdfReport && !report.reportEndpoint)) {
      console.log('Report will load once there is an endpoint hooked up to the UI for this report!')
    } else {
      if (setShowBatchReport) {
        await setShowBatchReport(false);
      }
      await fetchReport(report);

      if (report.pdfReport) {
        await setDownloadPdfFileName(report.pdfFileName);
      } else {
        await setReportInfo(report);
      }
    }
  }

  const clearShowReport = async () => {
    await setReportInfo(null);
    if (setShowBatchReport) {
      await setShowBatchReport(true);
    }
    await dispatch(clearActiveReport());
  }

  const [schoolCount, totalSchools] = (useSchoolCount) ? checkSchoolReportsCount(schoolStatuses, reportType) : [null, null];

  const reportOptions = <>
      {(studentReports) ? <Reports title="Student Reports" reports={studentReports} onClickAction={onClickAction}/> : ''}
      {(schoolReports) ? <Reports title="School Reports" reports={schoolReports} onClickAction={onClickAction}/> : ''}
      {(districtOverviewReports) ? <Reports title="District Overview Reports" reports={districtOverviewReports} onClickAction={onClickAction}/> : ''}
      {(additionalReports) ? <Reports title="Additional Reports" reports={additionalReports} onClickAction={onClickAction}/> : ''}
    </>;

  return (useSchoolCount && !schoolCount) ? <NoReports schoolCount={schoolCount} totalSchools={totalSchools} showSampleReports={showSampleReports} message={noReportsMessage} reportType={reportType}/> : (
    <div className='report-tab'>
      {(reportType === 'Sample') ? backToMyReports : ''}
      <h1 className="title">{tabTitle}</h1>
      {(reportInfo) ?  <ShowReport reportInfo={reportInfo} activeReport={activeReport} pdfReport={pdfReport} reportType={reportType} onReportClear={clearShowReport} backToLabel={backToLabel}/> : reportOptions}
    </div>
    );
}

export default ReportTab;